<template>
  <b-card no-body class="mt-6">
    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light table-th-color table-textcenter"
      :data="aboutcampaignBanner.result"
      border
    >
      <el-table-column
        label="Image"
        prop="image"
        min-width="100px"
        min-height="100px"
      >
        <template slot-scope="scope">
          <img :src="`${$imageURL}/${scope.row.image}`" alt="image" />
        </template>
      </el-table-column>
      <el-table-column label="Heading" prop="title">
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.heading }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Subheading" prop="title">
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.subheading }}
          </p>
        </template>
      </el-table-column>
      <!-- <el-table-column label="Button" prop="title">
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.btnName }}
          </p>
        </template>
      </el-table-column> -->
      <el-table-column label="Date" prop="title">
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{
              new Date(row.createdAt).toLocaleDateString(undefined, {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            }}
          </p>
        </template>
      </el-table-column>

      <el-table-column
        label="Actions"
        min-width="40px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-6 text-blue-500 cursor-pointer"
              class="mr-2"
              @click="handleEdit(scope)"
            ></feather-icon>
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(scope)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="totalPages"
        @change="handlePageChange"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>

<script>
// import Data from "./Data";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Button,
} from "element-ui";

import { mapState } from "vuex";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 5,
      totalPages: 0,
      dummyData: [
        {
          title: "hello",
          date: "2022-05-23T06:54:54.830Z",
        },
      ],
    };
  },

  methods: {
    async function() {
      let payload = {
        limit: this.perPage,
        offset: (this.currentPage - 1) * this.perPage,
      };
      try {
        this.$store.dispatch(
          "campaignPageBanner/get_aboutcampaignsbanner",
          payload
        );
        this.totalPages = this.aboutcampaignBanner.totalCount;
      } catch (error) {
        console.log(error);
      }
    },

    async handleEdit(scope) {
      let { row } = scope;
      console.log(row);
      await this.$store.commit(
        "campaignPageBanner/SELECT_ABOUT_CAMPAIGN_BANNER",
        row
      );
      this.$router.push({ name: "editCampaign-banner" });
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      const payload = { _id: row._id };
      let loader = this.$loading();
      try {
        const data = await this.$store.dispatch(
          "campaignPageBanner/delete_aboutcampaignsbanner",
          payload
        );
        this.function();
        loader.close();
        if (data.code === 200) {
          await this.$swal({
            text: "Deleted successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
        }
      } catch (error) {
        loader.close();
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.function();
    },
  },
  computed: {
    ...mapState("campaignPageBanner", {
      aboutcampaignBanner: "aboutcampaignBanner",
    }),
  },
  mounted() {
    this.function();
    console.log("aboutcampaignBanner", this.aboutcampaignBanner);
  },
};
</script>

<style scoped>
.clr606266 {
  color: #606266;
}
</style>
